import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "antd/dist/reset.css";
import "@styles/styles.less";
import App from "./App.tsx";
import { STORAGE_KEYS, DEFAULT_THEME } from "@config/app.config";
import { apiClient } from "@api/apiClient";
import { getLocalStorage } from "@common";

const originalWarn = console.warn;

console.warn = (...args: unknown[]) => {
  // Only check first argument if it's a string to avoid circular reference issues
  if (args.length > 0 && typeof args[0] === 'string') {
    const message = args[0];
    if (
      message.includes('[antd: compatible]') ||
      message.includes('antd v5 support React') ||
      message.includes('circular references')
    ) {
      return; // Suppress this specific warning
    }
  }
  originalWarn.apply(console, args);
};

console.error = (...args: unknown[]) => {
  // Only check first argument if it's a string to avoid circular reference issues
  if (args.length > 0 && typeof args[0] === 'string') {
    const message = args[0];
    if (
      (message.includes('Warning:') && message.includes('[antd: compatible]')) ||
      message.includes('antd v5 support React') ||
      (message.includes('Warning:') && message.includes('circular references'))
    ) {
      return; 
    }
  }
};

const savedTheme = getLocalStorage(STORAGE_KEYS.THEME_STORAGE);
if (savedTheme) {
  try {
    const parsed = JSON.parse(savedTheme);
    if (parsed.state?.theme) {
      document.documentElement.setAttribute("data-theme", parsed.state.theme);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    document.documentElement.setAttribute("data-theme", DEFAULT_THEME);
  }
} else {
  document.documentElement.setAttribute("data-theme", DEFAULT_THEME);
}

const existingToken = getLocalStorage(STORAGE_KEYS.AUTH_TOKEN);
if (existingToken) {
  apiClient.setToken(existingToken);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
